import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { selectUserInfo } from "store/user/userSlice"
import { UserStatusTypes } from "types"

export const ActiveUserLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { status: userStatus, username } = useAppSelector(selectUserInfo)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)
  const isActivateAccountRoute = location.pathname === "/activate-account"

  useEffect(() => {
    if (!username) navigate("/login", { replace: true })
    else if (userStatus)
      if (userStatus !== UserStatusTypes.ACTIVE) {
        if (!isActivateAccountRoute) navigate("/activate-account", { replace: true })
      } else if (isActivateAccountRoute) {
        navigate("/home", { replace: true })
      }

    setIsCheckingAuth(false)
  }, [isActivateAccountRoute, navigate, userStatus, username])

  if (isCheckingAuth) return <div className="flex h-screen w-screen items-center justify-center" />

  return <Outlet />
}
